import { RouteLocationNormalizedGeneric } from "vue-router";

const oauthKeys = Object.freeze([
  "access_token",
  "expires_at",
  "expires_in",
  "provider_token",
  "refresh_token",
  "token_type",
  "type",
] as const);

type OAuthParams = {
  [K in typeof oauthKeys[number]]?: string | null | undefined;
};

export default function (route: RouteLocationNormalizedGeneric): OAuthParams {
  const oauthHash = route.hash.match(/#(access_token=.+)/)?.at(1);
  if (!oauthHash) return {};

  const params = new URLSearchParams(oauthHash);
  return Object.fromEntries(Array.from(params.entries()).filter(([key]) => oauthKeys.includes(key as any)));
}
